
import { of } from "rxjs";

export class UnavailableAssessmentModal {
    message: string;
    continue: string;
    title: string;
    constructor() {
        this.title = 'Warning';
        this.message = ' The assessment is currently unavailable.'
        this.continue = 'Return to Dashboard'
    }

    build(): any {
        return of({
            title: this.title ? this.title : '',
            message: this.message ? this.message : '',
            size: 'md',
            buttons: {
                close: {
                    label: this.continue ? this.continue : '',
                    className: 'btn-primary mx-auto text-capitalize'
                }
            }
        });
    }
}
